<!-- @format -->

<template>
	<div class="workbench-home">
		<template v-if="list.length === 1">
			<template v-for="item in list" :key="item.id">
				<div class="edit-btn">
					<el-button v-if="hasButtonPermission('system:template:adminEdit')" @click="handleClick(item.alias, true)">
						编辑模版(通用)
					</el-button>
					<el-button v-if="hasButtonPermission('system:template:edit')" @click="handleClick(item.alias, false)">
						编辑模版(个人)
					</el-button>
				</div>
				<workbenchAll
					:module-type="item.alias"
					:env-url="envUrl"
					:components-obj="componentsObj"
					:components-setting="componentsSetting"
					style="padding-top: 0"
					class="carouselAll"
				/>
			</template>
		</template>
		<el-carousel v-else :autoplay="false" height="100%" class="carouselAll">
			<template v-for="item in list" :key="item.id">
				<el-carousel-item>
					<div class="edit-btn">
						<el-button v-if="hasButtonPermission('system:template:adminEdit')" @click="handleClick(item.alias, true)">
							编辑模版(通用)
						</el-button>
						<el-button v-if="hasButtonPermission('system:template:edit')" @click="handleClick(item.alias, false)">
							编辑模版(个人)
						</el-button>
					</div>
					<workbenchAll
						:module-type="item.alias"
						:env-url="envUrl"
						:components-obj="componentsObj"
						:components-setting="componentsSetting"
						style="padding-top: 0"
					/>
				</el-carousel-item>
			</template>
		</el-carousel>
	</div>
</template>

<script lang="ts" setup>
	import { hasButtonPermission } from '@power/runtime-vue3';
	import workbenchAll from './edit.vue';
	import { useMenuStoreWithOut } from '@/store/modules/menu';

	interface Props {
		envUrl: String;
		componentsObj?: any;
		componentsSetting?: any;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const menuStore = useMenuStoreWithOut();

	const list = computed(() => {
		return menuStore.menusRes.filter(
			(item) => !item.hidden && item.resourceType === 'menu' && item.defaultUrl.includes('workbenchAll'),
		);
	});

	const handleClick = (alias: string, isEdit: boolean) => {
		const url = `${props.envUrl}workbenchAll/${alias}/${isEdit ? 'adminEdit' : 'edit'}`;
		window.open(url);
	};
</script>

<style lang="scss" scoped>
	.workbench-home {
		position: relative;
		height: 100%;
		background-color: var(--theme-bg-color);

		.edit-btn {
			position: absolute;
			top: 10px;
			right: 20px;
			z-index: 100;
			width: 270px;
			height: 45px;
			text-align: right;

			.el-button {
				display: none;
			}

			&:hover .el-button {
				display: inline-block;
			}
		}

		.carouselAll {
			height: 100%;
			// margin-top: $base-header-height;
			// height: calc(100vh - $base-header-height);

			:deep .el-carousel__arrow {
				width: 25px;
				border-radius: 0;
				background-color: #000;
				opacity: 0.8;

				.el-icon {
					color: #fff;
				}
			}

			:deep .el-carousel__arrow--left {
				left: 30px;
			}

			:deep .el-carousel__arrow--right {
				right: 30px;
			}
		}
	}
</style>
